<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    :clear-on-destroy="!isEdit"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <PTOProjectTitle v-if="isEdit" is-edit />

    <VInput
      label="№ заявки"
      name="request_number"
      required
    >
      <Validation for="required">Поле обязательно</Validation>
    </VInput>

    <AppInputDate
      title="Дата заявки"
      name="request_date"
      type="single"
    />

    <AppInputDate
      title="Срок поставки"
      name="delivery_date"
      type="single"
    />

    <VCheckbox
      title="Согласование тех. директора"
      name="agreement"
      class="form__checkbox-wrap"
    />

    <VSelect
      label="МОЛ"
      name="mol"
      :items="userList"
      :handler-search="GETUserList"
      search
      userSelect
    />

    <VSelectJob
      label="Добавить работы"
      name="jobs"
      :items="projectPTOJobList"
      :handler-search="GETProjectPTOJobList"
      class="form__input--col-2"
    />
  </FormPto>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import FormPto from '@/components/pto/form/FormPto'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import Validation from '@/components/page/Form/Validation.vue'
import VCheckbox from '@/components/page/Form/VCheckbox/VCheckbox'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect'
import VSelectJob from '@/components/page/Form/VSelectJob.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'
import { mixinPtoProjectPTOJobSelect } from '@/mixins/module/pto/mixinPtoProjectPTOJobSelect'

import { prepareProjectPtoSupplyFormData } from '@/utils/page/pto/project/pto'

export default {
  name: 'FormPtoProjectPtoSupply',
  components: {
    AppInputDate,
    FormPto,
    PTOProjectTitle,
    Validation,
    VCheckbox,
    VInput,
    VSelect,
    VSelectJob
  },

  mixins: [
    MIXIN_FORM_PTO,
    MIXIN_USER_LIST,
    mixinPtoProjectPTOJobSelect
  ],

  methods: {
    onSubmit (data) {
      this.$emit('request', prepareProjectPtoSupplyFormData(data))
    }
  }
}
</script>
